window.debounce = function (fn, time) {
  var timeout = null;
  return function() {
    if(!timeout) {
      timeout = setTimeout(function() { fn(); timeout = null; }, time);
    }
  }
}

jQuery(function($) {
  $('[data-exclusive]').on('click', function() {
    var $this = $(this);
    if($this.is(':checked')) {
      var val = $this.data('exclusive');
      $('[data-exclusive="' + val + '"]').not($this).prop('checked', false);
    }
  });

  $('.js-property-filter-select').select2({
    width: '100%',
    minimumResultsForSearch: -1,
    theme: 'property-filter'
  });

  var $body = $('body');
  $body.on('change', '.js-filter select', function() {
    $(this).closest('form').submit();
  });
  $('.js-filter-submit').css({ display: 'none' });

  $body.on('click', function(e) {
    if(!$(e.target).closest('.js-header').length) {
      $('.js-header-toggle').prop('checked', false);
    }
  });

  $('.js-value-link').on('click', function(e) {
    e.preventDefault();
    $('.values-careers--current').removeClass('values-careers--current');
    var $this = $(this).addClass('values-careers--current');
    var $target = $($this.attr('href'));
    if($target.length) {
      $target.addClass('values-careers--current');
    }
  });

  $('.js-header nav a').on('click', function() {
    $('.js-header-toggle').prop('checked', false);
  });
});